import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { UserManageRolesResponse } from "../../usersManagement/UserManageRolesResponse";

interface Props {
  onAuthError?: () => void;
}
export default class UTP2AccountsAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.UTP2_API}/api/Accounts`;

  getClaimRoles = async (username: string | undefined): Promise<UserManageRolesResponse[] | null> => {
    const data = await this.apiResponseHandler.get(`${UTP2AccountsAPIs.BASE_URL}/roles/${username}`);
    if (!data) {
      return null;
    }
    return data;
  };
}
